var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArchive1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "archive"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path 1731",
    d: "M8.7 23H15.3C20.8 23 23 20.8 23 15.3V8.7C23 3.2 20.8 1 15.3 1H8.7C3.2 1 1 3.2 1 8.7V15.3C1 20.8 3.2 23 8.7 23Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 1732",
    d: "M19 7.41694V14.1669C18.9507 13.5944 18.6787 13.064 18.2424 12.69C17.8061 12.316 17.2404 12.1281 16.667 12.1669H7.333C6.75963 12.1281 6.19393 12.316 5.75762 12.69C5.32132 13.064 5.04927 13.5944 5 14.1669V7.41694C5.04927 6.84437 5.32132 6.31402 5.75762 5.93999C6.19393 5.56596 6.75963 5.37814 7.333 5.41694H16.666C17.2395 5.37787 17.8055 5.56556 18.242 5.93962C18.6785 6.31368 18.9507 6.84419 19 7.41694Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 1733",
    d: "M20 16.125H19",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 1734",
    d: "M5 16.125H4",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 1735",
    d: "M19 13.933V10.933C18.9507 10.3604 18.6787 9.83006 18.2424 9.45603C17.8061 9.082 17.2404 8.89418 16.667 8.93299H7.333C6.75963 8.89418 6.19393 9.082 5.75762 9.45603C5.32132 9.83006 5.04927 10.3604 5 10.933V13.933",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 1736",
    d: "M19 13.974V15.224H14.917C14.8572 15.9406 14.5176 16.6048 13.9716 17.0727C13.4256 17.5406 12.7173 17.7746 12 17.724C11.2827 17.7746 10.5744 17.5406 10.0284 17.0727C9.48242 16.6048 9.14276 15.9406 9.083 15.224H5V13.974C5.04927 13.4014 5.32132 12.8711 5.75762 12.497C6.19393 12.123 6.75963 11.9352 7.333 11.974H16.666C17.2585 11.9868 17.8313 12.1886 18.301 12.55C18.522 12.715 18.7006 12.9302 18.8221 13.1778C18.9436 13.4253 19.0046 13.6982 19 13.974Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchive1);
export default __webpack_public_path__ + "static/media/archive (1).915ee09ff5e912f799fc2d6f70db65ba.svg";
export { ForwardRef as ReactComponent };